import { useMutation, useQueryClient } from '@tanstack/react-query';
import { myProfileApi } from '../api/myProfileApi';

/**
 * DELETE /api/eraf/me/avatar — 아바타 삭제
 * 성공 시 ['my-profile'] 쿼리 무효화 (profileImageId → null)
 */
export function useDeleteAvatar() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: () => myProfileApi.deleteAvatar(),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['my-profile'] });
    },
  });
}
